import * as React from 'react'
import Link from 'next/link'

import { Message } from '~/components'
import { useModalManager } from '~/hooks'
import { images } from '~/utils/constants'

import { ModalContainer, StyledButton } from './elements'
import Header from './header'

const OrdersToBeApprovedAlert = props => {
  const { initialOrderStatusId, modalId } = props

  const { closeModal } = useModalManager()

  return (
    <ModalContainer>
      <Header onClose={() => closeModal(modalId)} />
      <Message
        title="Tienes cambios por aprobar"
        content="Algunos de los pedidos registrados en la tienda han tenido cambios y esperan de tu aprobación para continuar siendo atendidos."
        imageSrc={images.ILLUSTRATION_PAPER_PROBLEM}
      />
      <Link href={`/mi-cuenta/pedidos?status=${initialOrderStatusId}`}>
        <StyledButton onClick={() => closeModal(modalId)}>Ver pedidos</StyledButton>
      </Link>
    </ModalContainer>
  )
}

export default OrdersToBeApprovedAlert
